var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7583 0.805456C16.8323 1.8794 16.8323 3.6206 15.7583 4.69454L5.60196 14.8509C5.16141 15.2915 4.60942 15.604 4.00499 15.7551L0.854869 16.5426C0.351357 16.6685 -0.104725 16.2124 0.0211527 15.7089L0.808684 12.5588C0.95979 11.9544 1.27232 11.4024 1.71287 10.9618L11.8693 0.805456C12.9432 -0.268485 14.6844 -0.268485 15.7583 0.805456ZM10.8969 3.72212L2.68514 11.9341C2.42081 12.1984 2.23329 12.5296 2.14263 12.8923L1.633 14.9308L3.67151 14.4212C4.03416 14.3305 4.36536 14.143 4.62968 13.8787L12.8411 5.66637L10.8969 3.72212ZM12.8415 1.77773L11.869 2.75L13.8133 4.69425L14.7861 3.72227C15.323 3.1853 15.323 2.3147 14.7861 1.77773C14.2491 1.24076 13.3785 1.24076 12.8415 1.77773Z",
    fill: "#FD7900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.2b837431cb52670fdf9092f87464e563.svg";
export { ForwardRef as ReactComponent };